var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "upload-ad second border-radius-top p-4 d-flex flex-md-row justify-content-between"
      },
      [
        _c(
          "vue-dropzone",
          {
            ref: "vueDropzone",
            attrs: {
              id: "dropzone",
              options: _vm.dropzoneOptions,
              useCustomSlot: true
            },
            on: {
              "vdropzone-file-added": _vm.fileAdded,
              "vdropzone-thumbnail": _vm.thumbnailCreated
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "dropzone-custom-content d-flex align-self-center"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-fill col-2 d-inline-flex flex-column justify-content-center align-self-center align-items-center"
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "dropzone-custom-title font-weight-bold fs-16"
                      },
                      [_vm._v("Drag, drop or click to upload your advert")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "subtitle fs-16" }, [
                      _vm._v("624px x 312px")
                    ])
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "preview-container position-relative flex-fill col-2 d-inline-flex flex-column justify-content-center align-items-center border-radius bg-white ml-md-4 "
          },
          [
            !_vm.file && !_vm.filePreview
              ? _c(
                  "div",
                  {
                    staticClass:
                      "preview-placeholder text-uppercase d-flex justify-content-center align-self-center align-items-center align-self-center"
                  },
                  [_vm._v("\n                Your Advert\n            ")]
                )
              : _c("div", { staticClass: "preview-file-container" }, [
                  _c("img", {
                    staticClass: "preview-file-image border-radius",
                    attrs: { src: _vm.filePreview, alt: "File Preview" }
                  }),
                  _vm._v(" "),
                  _vm.filePreview
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-uppercase fs-12 t-white position-absolute preview-remove mt-1",
                          on: { click: _vm.removeFile }
                        },
                        [
                          _vm._v(
                            "\n                    Remove\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        {
          staticClass:
            "container d-flex flex-column flex-sm-row row-cols-2 border-radius-bottom upload-url bg-white row p-4 h-auto"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-sm-5 d-inline-flex flex-fill flex-column mr-sm-3 pb-3 pb-sm-0 w-100"
            },
            [
              _c(
                "label",
                { staticClass: "ad-label fs-16 mb-1 d-inline-block" },
                [_vm._v("\n                    Advert URL\n                ")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.advertUrl,
                    expression: "advertUrl"
                  }
                ],
                ref: "urlField",
                staticClass: "input-link fs-16 px-2",
                attrs: { type: "text" },
                domProps: { value: _vm.advertUrl },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.advertUrl = $event.target.value
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "button",
                {
                  staticClass:
                    "button-update fs-18 border-radius align-self-stretch flex-fill flex-grow-1 col-5 mh-100 py-2 py-sm-0 bg-orange t-white text-center",
                  attrs: { type: "submit" },
                  on: { click: _vm.update }
                },
                [_vm._v("\n                    Update\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("pulse-loader", {
                staticClass:
                  "d-flex justify-content-center align-items-center align-self-stretch flex-fill col-5 mh-100",
                attrs: { loading: true, color: "#E57722", size: "20px" }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c35306", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c35306","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Dropzone.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-65c35306","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Dropzone.vue
// module chunks = 0 1